import { Routes } from '@angular/router';
import { ParticipantsComponent } from './components/participant/participants.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './auth/auth.guard';
import { PairsComponent } from './components/pair/pairs.component';
import { NewsitemsComponent } from './components/newsitem/newsitems.component';
import { EnisImportComponent } from './enis-import/enis-import.component';
import { Permission } from './interfaces/permission';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { PairHistoryComponent } from './components/history/pair-history/pair-history.component';
import { ParticipantHistoryBoxComponent } from './components/history/participant-history-box/participant-history-box.component';
import { ParticipantHistoryComponent } from './components/history/participant-history/participant-history.component';
import { ApprovalsComponent } from './components/approvals/approvals.component';
import { CrossmatchComponent } from './components/crossmatch/crossmatch.component';
import { MatchComponent } from './components/match/match.component';
import { MatchStartComponent } from './components/match-run/match-start/match-start.component';
import { MatchRunComponent } from './components/match-run/match-run.component';
import { CombinationComponent } from './components/combinations/combination.component';
import { CentersManagementComponent } from './components/centers/centers-management.component';
import { HistoricalParticipantsComponent } from './components/historical/historical-participants.component';
import { EnisSyncLogComponent } from './enis-sync-log/enis-sync-log.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: DashboardComponent,
    data: { permission: Permission.DASHBOARD_READ }
  },
  {
    path: 'participants',
    canActivate: [authGuard],
    component: ParticipantsComponent,
    data: { permission: Permission.PARTICIPANTS_PAGE }
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'pairs',
    canActivate: [authGuard],
    component: PairsComponent,
    data: { permission: Permission.PAIRS_PAGE }
  },
  {
    path: 'historical',
    canActivate: [authGuard],
    component: HistoricalParticipantsComponent,
    data: { permission: Permission.PARTICIPANTS_HISTORICAL_PAGE }
  },
  {
    path: 'newsitems',
    canActivate: [authGuard],
    component: NewsitemsComponent,
    data: { permission: Permission.NEWSITEM_PAGE }
  },
  {
    path: 'timeline/:id',
    canActivate: [authGuard],
    component: TimelineComponent,
    data: { permission: Permission.TIMELINE_PAGE }
  },
  {
    path: 'history/pair/:id',
    canActivate: [authGuard],
    component: PairHistoryComponent,
    data: { permission: Permission.PAIR_HISTORY_PAGE }
  },
  {
    path: 'history/donor/:id',
    canActivate: [authGuard],
    component: ParticipantHistoryComponent,
    data: { permission: Permission.PARTICIPANTS_HISTORY_PAGE }
  },
  {
    path: 'history/recipient/:id',
    canActivate: [authGuard],
    component: ParticipantHistoryComponent,
    data: { permission: Permission.PARTICIPANTS_HISTORY_PAGE }
  },
  {
    path: 'approvals',
    canActivate: [authGuard],
    component: ApprovalsComponent,
    data: { permission: Permission.APPROVAL_PAGE }
  },
  {
    path: 'crossmatch',
    canActivate: [authGuard],
    component: CrossmatchComponent,
    data: { permission: Permission.CROSSMATCH_PAGE }
  },
  {
    path: 'combination',
    canActivate: [authGuard],
    component: CombinationComponent,
    data: { permission: Permission.CROSSMATCH_PAGE }
  },
  {
    path: 'matchrun/:matchperiodid/:matchrunid',
    canActivate: [authGuard],
    component: MatchComponent,
    data: { permission: Permission.MATCHRUN_PAGE }
  },
  {
    path: 'matchstart',
    canActivate: [authGuard],
    component: MatchRunComponent,
    data: { permission: Permission.MATCHRUN_START }
  },
  {
    path: 'centers',
    canActivate: [authGuard],
    component: CentersManagementComponent,
    data: { permission: Permission.CENTERS_PAGE }
  },
  {
    path: 'enissync-log',
    canActivate: [authGuard],
    component: EnisSyncLogComponent,
    data: { permission: Permission.ENISSYNC_VIEW_LOGS }
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  }
];
